export default __webpack_public_path__ + "media/images/amenities/microwave-a2489c4c4172234562cf16db8d52fe0e.jpeg";